export default class PublishButtonStatusUpdate {
  public static EVENT_TYPE: string = 'publishButtonStatusUpdate';

  public static dispatchEvent() {
    const event = new CustomEvent(this.EVENT_TYPE);
    window.dispatchEvent(event);
  }
}
